import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../firebase';

/**
 * Marking of the written notes in an information-transfer task (telc C1
 * Hochschule, Hörverstehen Teil 3, items 65–74): the scoreListeningNotes
 * function gives each note 0, 1 or 2 points, as a telc rater does. Shared by
 * the digital results page and the paper exam, so both score alike.
 */

/** The notes part of a paper, or null when it has none. */
export const notesPartOf = (exam) => (exam?.sections || [])
  .flatMap((s) => s.parts || [])
  .find((p) => p.taskType === 'information-transfer-notes') || null;

/**
 * @returns {Promise<{ status: 'done'|'empty'|'signin'|'error', scores?: Record<string, {points:number, reason:string}> }>}
 */
export const scoreListeningNotes = async (exam, finalAnswers) => {
  const part = notesPartOf(exam);
  if (!part) return { status: 'empty' };
  const notes = finalAnswers?.[part.partId] || {};
  const answers = Object.fromEntries(Object.entries(notes)
    .filter(([, text]) => typeof text === 'string' && text.trim())
    .map(([id, text]) => [id, text.trim()]));
  if (!Object.keys(answers).length) return { status: 'empty', scores: {} };
  if (!auth.currentUser) return { status: 'signin' };
  if (!exam.examFileName) return { status: 'error' };
  try {
    const call = httpsCallable(functions, 'scoreListeningNotes');
    const { data } = await call({
      provider: String(exam.examProvider || '').toLowerCase(),
      level: String(exam.level || '').toLowerCase(),
      file: exam.examFileName,
      answers,
    });
    return { status: 'done', scores: data?.scores || {} };
  } catch (error) {
    console.error('Notes could not be marked:', error);
    return { status: 'error' };
  }
};

/** { [questionId]: points } for examService.calculateFinalScore's notesPoints. */
export const notesPointsOf = (scores) => Object.fromEntries(
  Object.entries(scores || {}).map(([id, s]) => [id, s?.points ?? 0]),
);
